export { default as UserNoAvatar } from './UserNoAvatar';
